var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContractDoc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13760_19533)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.875 16.8125C16.875 17.1109 16.7565 17.397 16.5455 17.608C16.3345 17.819 16.0484 17.9375 15.75 17.9375H2.25C1.95163 17.9375 1.66548 17.819 1.4545 17.608C1.24353 17.397 1.125 17.1109 1.125 16.8125V2.1875C1.125 1.88913 1.24353 1.60298 1.4545 1.39201C1.66548 1.18103 1.95163 1.0625 2.25 1.0625H13.5338C13.8274 1.06233 14.1095 1.177 14.3198 1.382L16.5353 3.54425C16.6428 3.64905 16.7282 3.77431 16.7866 3.91265C16.8449 4.05099 16.875 4.19961 16.875 4.34975V16.8125Z",
    stroke: "#CF0A2C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.53369 6.6875H13.5337",
    stroke: "#CF0A2C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.53369 10.0625H13.5337",
    stroke: "#CF0A2C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.53369 13.4375H9.03369",
    stroke: "#CF0A2C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13760_19533"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContractDoc);
export default __webpack_public_path__ + "static/media/contract_doc.02deb7b2bf58f2212e3513479adf9285.svg";
export { ForwardRef as ReactComponent };